module.exports = __webpack_public_path__ + "img/dku.00002.ebc91d25.png";